module.exports = __webpack_public_path__ + "img/triangle.e8a52397.svg";